var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramSaving64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Saving64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(5.000000, 7.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "50c",
    fill: "#FFFFFF",
    points: "18 0 28.5801345 3.4376941 35.1190173 12.4376941 35.1190173 23.5623059 28.5801345 32.5623059 18 36 7.41986546 32.5623059 0.880982707 23.5623059 0.880982707 12.4376941 7.41986546 3.4376941"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "20c",
    fill: "#FFFFFF",
    cx: 39,
    cy: 29,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(6.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    fill: "#FFCC00",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(9.000000, 5.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99786377,2 L2.99786377,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,14 L3,12",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,2 C3.58714125,2 3.42047458,2 2.5,2 C1.11928813,2 0,3.11928813 0,4.5 C0,5.88071187 1.11928813,7 2.5,7 L3.5,7 C4.88071187,7 6,8.11928813 6,9.5 C6,10.8807119 4.88071187,12 3.5,12 C2.57952542,12 2.41285875,12 1,12",
    id: "Oval-2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramSaving64);
export default __webpack_public_path__ + "static/media/pictogramSaving64.6449411c52b28b21fe2ec1e20c5538d4.svg";
export { ForwardRef as ReactComponent };